export const IconSelectSearch = (props) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.3023 12.1664C9.23068 12.1664 11.6046 9.77867 11.6046 6.83322C11.6046 3.88776 9.23068 1.5 6.3023 1.5C3.37392 1.5 1 3.88776 1 6.83322C1 9.77867 3.37392 12.1664 6.3023 12.1664Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.93 13.5015L10.0469 10.6016"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
